import 'core-js/stable';

if (typeof window !== 'undefined' && (/Safari/).test(navigator.userAgent) && !(/Chrome/).test(navigator.userAgent)) {
  if (!Object.getPrototypeOf) {
    Object.getPrototypeOf = function (obj) {
      if (obj === null || obj === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      return obj.__proto__ || Object.prototype;
    };
  }

  if (!Reflect || !Reflect.getPrototypeOf) {
    if (!window.Reflect) {
      window.Reflect = {};
    }
    Reflect.getPrototypeOf = function (target) {
      if (target === null || target === undefined) {
        throw new TypeError('Cannot convert undefined or null to object');
      }
      return Object.getPrototypeOf(target);
    };
  }
}
